import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is an AI Bottleneck Assessment?",
    a: "It's a focused diagnostic of your business. We identify the three specific places you're losing time, leads or revenue, then map out practical AI and automation fixes — ranked by effort versus impact. It's diagnosis first, implementation second.",
  },
  {
    q: "Is this only for tech companies?",
    a: "No — in fact, it's built for the opposite. Most of our value lands with non-technical businesses: home services, ecommerce, real estate, operations-heavy small teams. If your business runs on inbox, spreadsheets and good intentions, you're exactly who this is for.",
  },
  {
    q: "Do I need to already use AI?",
    a: "Not at all. Many clients haven't adopted any AI yet — and that's fine. We start from how your business actually runs today. Where AI makes sense, we'll recommend it. Where it doesn't, we'll tell you so.",
  },
  {
    q: "What happens after the assessment?",
    a: "You receive your Bottleneck Scorecard, top three priorities and a prioritised roadmap with tool and workflow recommendations. From there you can implement in-house, with your existing team, or ask us to build the first fix for you.",
  },
  {
    q: "Can you also implement the solutions?",
    a: "Yes — on a case-by-case basis. We scope the first fix as a tight, fixed-outcome engagement rather than an open-ended retainer, so you know exactly what you're paying for and what you're getting.",
  },
  {
    q: "How much does it cost?",
    a: "The assessment is priced as a focused flat fee so there are no surprises. Book a call and we'll confirm pricing based on the size of your business and complexity of the workflow.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="bg-[#FAFAFA] border-b border-zinc-200"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 reveal">
            <div className="flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-orange-600" />
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">
                FAQ
              </span>
            </div>
            <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.02] tracking-tight text-zinc-950">
              Straight answers.
            </h2>
            <p className="mt-6 text-zinc-600 leading-relaxed">
              If your question isn't here, ask it in the form below. We'll get back to you
              directly — no drip sequence, no gated PDF.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="border-t border-zinc-200"
              data-testid="faq-accordion"
            >
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-zinc-200"
                >
                  <AccordionTrigger
                    className="py-6 text-left font-display font-semibold text-lg sm:text-xl text-zinc-950 hover:no-underline tracking-tight"
                    data-testid={`faq-trigger-${i}`}
                  >
                    <span className="flex items-start gap-5">
                      <span className="font-mono text-xs text-orange-600 mt-1.5 tabular-nums">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span>{f.q}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-10 text-zinc-600 leading-relaxed text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
